import React from "react";

import { FormFieldErrorMessage } from "~/components/form/error-message";
import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { WidgetCalculationField } from "../../../widget-form/calculation";
import { WidgetDecimalsField } from "../../../widget-form/decimals";
import { WidgetRangeField } from "../../../widget-form/range";
import { WidgetRange } from "../../../widget-form/range/form-state";
import { WidgetUnitField } from "../../../widget-form/unit";
import { SettingsSectionFormField } from "../_field";
import { ResetToDefaultSection } from "../_reset-to-default-section";
import { SettingsSectionGrid } from "../_section-grid";
import { ThresholdsSection } from "../_thresholds/section";

import { FormState } from "./form-state";

export interface GaugeChartSettingsProps {
	settings: FormState;
}

export const GaugeChartSettings: React.FC<GaugeChartSettingsProps> = ({ settings }) => (
	<div className="grid h-full grid-cols-3 gap-4">
		<Widget>
			<WidgetHeader className="uppercase" title="Misc">
				<FormFieldReset
					className="ml-auto"
					state={[settings.fields.unit, settings.fields.decimals, settings.fields.max, settings.fields.calculation]}
				/>
			</WidgetHeader>

			<WidgetBody card>
				<SettingsSectionGrid className="grid-cols-[auto_1fr]">
					<SettingsSectionFormField layout="horizontal" state={settings.fields.unit}>
						<FormLabel>Unit</FormLabel>
						<WidgetUnitField className="w-full" default={undefined} unit={settings.fields.unit} />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.decimals}>
						<FormLabel>Decimals</FormLabel>
						<WidgetDecimalsField decimals={settings.fields.decimals} name="dashboard-widget-settings-decimal-places" />
						<FormFieldErrorMessage className="col-span-full" />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.max}>
						<FormLabel>Max</FormLabel>
						<WidgetRangeField
							default={WidgetRange.max("GaugeChart")}
							name="dashboard-widget-y-axis-max"
							value={settings.fields.max}
						/>
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.calculation}>
						<FormLabel>Calculation</FormLabel>
						<WidgetCalculationField calculation={settings.fields.calculation} name="dashboard-widget-misc-calculated" />
					</SettingsSectionFormField>
				</SettingsSectionGrid>
			</WidgetBody>
		</Widget>

		<div className="flex flex-col gap-4">
			<Widget>
				<WidgetHeader className="uppercase" title="Thresholds">
					<FormFieldReset className="ml-auto" state={[settings.fields.color, settings.fields.thresholds]} />
				</WidgetHeader>

				<WidgetBody card>
					<ThresholdsSection
						defaultColor={settings.fields.color}
						mode={settings.fields.thresholds.fields.mode}
						thresholds={settings.fields.thresholds.fields.steps}
					/>
				</WidgetBody>
			</Widget>

			<ResetToDefaultSection onClick={() => FormState.resetToDefault(settings)} />
		</div>
	</div>
);
